<div class="skeleton" #skeleton></div>
